import { EstadoBolsa } from './bolsaMachine';
import { BolsaCentro } from '../types';

export interface PuntoMes {
  mes: string; // "ene", "feb", ...
  cotizado: number;
  ganado: number;
}

const MESES_CORTOS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

// Decisión de implementación (sin CA que fije valores exactos de la gráfica): "cotizado" se
// aproxima por el mes de creación de la bolsa/cotización; "ganado" por el mes de su última
// actualización cuando el estado actual es GANADA (la bolsa deja de mutar tras marcarse ganada).
export function calcularSerieMensual(bolsas: BolsaCentro[], meses = 6): PuntoMes[] {
  const hoy = new Date();
  const puntos: PuntoMes[] = [];

  for (let i = meses - 1; i >= 0; i -= 1) {
    const fecha = new Date(hoy.getFullYear(), hoy.getMonth() - i, 1);
    puntos.push({ mes: MESES_CORTOS[fecha.getMonth()], cotizado: 0, ganado: 0 });
  }

  const claveDe = (fecha: Date) => `${fecha.getFullYear()}-${fecha.getMonth()}`;
  const indicePorClave = new Map<string, number>();
  for (let i = meses - 1; i >= 0; i -= 1) {
    const fecha = new Date(hoy.getFullYear(), hoy.getMonth() - i, 1);
    indicePorClave.set(claveDe(fecha), meses - 1 - i);
  }

  for (const bolsa of bolsas) {
    const creada = new Date(bolsa.createdAt);
    const idxCreada = indicePorClave.get(claveDe(creada));
    if (idxCreada !== undefined) {
      puntos[idxCreada].cotizado += bolsa.total;
    }
    if (bolsa.estado_codigo === EstadoBolsa.GANADA) {
      const actualizada = new Date(bolsa.updatedAt);
      const idxGanada = indicePorClave.get(claveDe(actualizada));
      if (idxGanada !== undefined) {
        puntos[idxGanada].ganado += bolsa.total;
      }
    }
  }

  return puntos;
}

export function serieSparkline(bolsas: BolsaCentro[], campo: 'cotizado' | 'ganado', meses = 6): number[] {
  return calcularSerieMensual(bolsas, meses).map((p) => p[campo]);
}
